<template>
  <ConfiguracionComponent :variadores="variadores" :loading="loading" @onInsertCabezal="handleInsertCabezal"
    @onUpdateCabezal="handleUpdateCabezal" @onDeleteCabezal="handleDeleteCabezal" />
</template>

<script>
import ConfiguracionComponent from '@/components/ConfiguracionComponent'
import { getVariadores, insertCabezal, deleteCabezal } from "@/data/variadoresData";

export default {
  components: {
    ConfiguracionComponent
  },
  data() {
    return {
      variadores: null,
      loading: false,
    };
  },
  methods: {
    async handleInsertCabezal(params) {
      try {
        await insertCabezal(params.id, params.presion_maxima, params.n_entrada, params.n_salida, params.criterio)

        const updated = await getVariadores();
        this.variadores = updated;
      } catch (error) {
        console.error("Error inserting cabezal:", error);
      }
    },

    async handleDeleteCabezal(id) {
      try {
        await deleteCabezal(id);

      } catch (error) {
        console.error("Error deleting cabezal:", error);
      } finally {

        const updated = await getVariadores();
        this.variadores = updated;

      }
    },

    async handleUpdateCabezal({ previousId, newData }) {
      try {
        await deleteCabezal(previousId);

        await insertCabezal(newData.id, newData.presion_maxima, newData.n_entrada, newData.n_salida, newData.criterio);
      } catch (error) {
        console.error("Error updating cabezal:", error);
      } finally {
        const updated = await getVariadores();
        this.variadores = updated;
      }
    }
  },
  async mounted() {
    try {
      this.loading = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      const variadores = await getVariadores();
      this.variadores = variadores;

    } catch (error) {
      console.error("Error fetching variadores:", error);
    } finally {
      this.loading = false;
    }
  },

}
</script>

<style></style>